import {userHasRole, userIsAdmin, userIsAdminOperator, userIsOrganizer, userIsUser} from "@/helpers/auth-helpers"

export default {
    computed: {
        userIsAdmin() {
            return userIsAdmin();
        },
        userIsAdminOperator() {
            return userIsAdminOperator();
        },
        userIsOrganizer() {
            return userIsOrganizer();
        },
        userIsUser() {
            return userIsUser();
        },
    },
    methods: {
        userHasRole(...roles) {
            return userHasRole(...roles);
        },
    }
};
